





























	import Vue from 'vue';
	import Component from 'vue-class-component';

	import AccueilEnfants from '@/components/santeEnfant/AccueilEnfants.vue';

	const Props = Vue.extend({
		props: {
			jsonenfants: {
				type: String,
				default: ''
			}
		}
	});

	@Component({
        components: {
			AccueilEnfants
        }
    })
	export default class AccueilSanteEnfant extends Props {
		get enfants() {
			let Objectenfants = JSON.parse(atob(this.jsonenfants));
			return Objectenfants.enfant;
		}
	}
